var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"video-player"},[_c('video',{ref:"videoPlayer",staticClass:"video-js"}),_c('base-button',{staticClass:"video-player__close",on:{"click":function($event){return _vm.$emit('close')}}},[_vm._v("Close")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }